import {
    Box,
    Button,
    FormControl,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Text
} from "@chakra-ui/react";
import { OrcamentoDeptoCategoria } from "models/orcamento_departamento";
import { useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { MdDelete, MdEdit } from "react-icons/md";
import formatNumber from "views/admin/order/hooks/formatNumber";
import DynamicOrcTable from "./DynamicOrcTable";
  
  
  interface ITemplateOrcData {
    showItemModal: (item: boolean) => void;
    showCategory: boolean;
    textColor: string;
    brandStars: string;
    borderColor: string;
    nomeRef: any;
    saveItem: (order: number) => void;
    changeItem: (item: OrcamentoDeptoCategoria) => void;
    removeItem: (item: OrcamentoDeptoCategoria) => void;
    itens: OrcamentoDeptoCategoria[];
    reorder: (
      list: OrcamentoDeptoCategoria[],
      startIndex: number,
      endIndex: number
    ) => void;
    drag: boolean;
    isDragable: (drag: boolean) => void;
  }
  
  const TemplateOrcData = ({
    showItemModal,
    showCategory,
    textColor,
    brandStars,
    nomeRef,
    saveItem,
    changeItem,
    removeItem,
    reorder,
    drag,
    itens,
    isDragable,
    borderColor
  }: ITemplateOrcData) => {
    const [selectedItem, setSelectedItem] =
      useState<OrcamentoDeptoCategoria>();
  
    const [isEdit, setIsEdit] = useState(false);
    const editItem = (item: OrcamentoDeptoCategoria) => {
      setIsEdit(true);
      nomeRef.current = item.descricao;
      showItemModal(true);
      setSelectedItem(item);
    };
  
    const saveEdit = () => {
      selectedItem.descricao = nomeRef.current;
      setIsEdit(false);
      nomeRef.current = "";
      changeItem(selectedItem);
      setSelectedItem(null);
      showItemModal(false);
    };
  
    const onDragEnd = (result: any) => {
      reorder(itens, result.source.index, result.destination.index);
    };
    return (
      <Box>
        <Stack>
          <Button
            marginY={-5}
            variant={"outline"}
            onClick={() => {
              showItemModal(true);
            }}
            alignSelf={"flex-end"}
            colorScheme="brand"
            isLoading={false}
          >
            Adicionar Novo Grupo
          </Button>
        </Stack>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {provided.placeholder}
                {itens?.map((item, index) => {
                  return (
                    <Draggable
                      key={`${item.id}`}
                      draggableId={`${item.id}-${item.descricao}-${index}`}
                      index={index}
                      isDragDisabled={drag}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <Box key={`${item.id}-${index}`} mb={16} mt={16}>
                            <Box flex="1" flexDirection={"row"}>
                              <Text
                                textAlign="left"
                                color={"#422AFB"}
                                fontWeight={"bold"}
                                fontSize={28}
                              >
                                {index + 1} - {item.descricao} - subtotal :{" "}
                                {formatNumber(Number(item.valor))}
                              </Text>
  
                              <Button
                                leftIcon={<MdDelete />}
                                colorScheme="red"
                                variant="solid"
                                float={"right"}
                                mt={-12}
                                onClick={() => removeItem(item)}
                              >
                                Excluir
                              </Button>
                              <Button
                                leftIcon={<MdEdit />}
                                colorScheme="green"
                                variant="solid"
                                float={"right"}
                                mt={-12}
                                mr={128}
                                onClick={() => {
                                  editItem(item);
                                }}
                              >
                                Editar
                              </Button>
                            </Box>
                            <DynamicOrcTable
                                borderColor={borderColor}
                                index={index}
                                changeItem1={changeItem}
                                isDragable={isDragable}
                                item={item}
                          />
                          </Box>
                        </div>
                      )}
                    </Draggable>
                  );
                })}
              </div>
            )}
          </Droppable>
        </DragDropContext>
  
        <Modal
          onClose={() => {
            showItemModal(false);
          }}
          size={"2xl"}
          isOpen={showCategory}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{isEdit ? "Editar Grupo" : "Novo Grupo"}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <FormControl>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  color={textColor}
                  mb="8px"
                >
                  Nome<Text color={brandStars}>*</Text>
                </FormLabel>
                <Input
                  ref={nomeRef}
                  defaultValue={nomeRef.current}
                  isRequired={true}
                  variant="auth"
                  fontSize="sm"
                  ms={{ base: "0px", md: "0px" }}
                  type="text"
                  placeholder="Preencha o nome do Grupo"
                  onChange={(e) => (nomeRef.current = e.target.value)}
                  mb="24px"
                  fontWeight="500"
                  size="lg"
                />
              </FormControl>
            </ModalBody>
            <ModalFooter>
              <Button
                onClick={() => {
                  showItemModal(false);
                }}
                variant="outline"
                marginRight={4}
              >
                Fechar
              </Button>
              <Button
                onClick={() => {
                  isEdit ? saveEdit() : saveItem(0);
                }}
                colorScheme="brand"
              >
                Salvar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>
    );
  };
  
  export default TemplateOrcData;
  